/**
 * Two areas (map „Plattform-Bereich“, ticket 01): the platform of the platform administration,
 * outside every municipality, and the workspace of one municipality. A platform admin enters a
 * municipality explicitly ("Kommune öffnen") and leaves it via "Alle Kommunen".
 */
export type Area = 'platform' | 'workspace'

const PLATFORM_PATHS = ['/plattform', '/verwaltung']

export const areaOf = (pathname: string): Area =>
  PLATFORM_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`)) ? 'platform' : 'workspace'

/** The two dashboards (decision 2026-11-03): each URL shows the same page in every context. */
export const PLATFORM_HOME = '/plattform/dashboard'
export const TENANT_HOME = '/dashboard'

/**
 * Where "/" leads: members to the dashboard of their municipality; platform admins to the
 * platform, unless they entered a municipality ("Kommune öffnen") and did not leave it yet.
 */
export const startPath = ({ platformAdmin, entered }: { platformAdmin: boolean; entered: boolean }) =>
  platformAdmin && !entered ? PLATFORM_HOME : TENANT_HOME

/** A platform admin who enters the platform (by "Alle Kommunen", the menu or a URL) leaves the
 * entered municipality: "/" then leads to the platform again. */
export const leaves = ({ pathname, platformAdmin, entered }: { pathname: string; platformAdmin: boolean; entered: boolean }) =>
  platformAdmin && entered && areaOf(pathname) === 'platform'

/**
 * What a page needs before it can render without a chosen municipality: platform pages and the
 * start page need none; platform admins go to the platform instead of choosing among tiles.
 */
export type Gate = 'page' | 'to-platform' | 'chooser' | 'no-access'

export function tenantGate({
  pathname,
  platformAdmin,
  hasTenant,
  tenantCount,
}: {
  pathname: string
  platformAdmin: boolean
  hasTenant: boolean
  tenantCount: number
}): Gate {
  if (hasTenant || pathname === '/' || areaOf(pathname) === 'platform') return 'page'
  if (platformAdmin) return 'to-platform'
  return tenantCount > 0 ? 'chooser' : 'no-access'
}
